import { createSlice } from "@reduxjs/toolkit";

const initialMovementsSlice = { 
        tanksounding: { 
                isLoading: false,
                report: [],
                tanks: []
        }, 
};

export const ReportsSlice = createSlice({
        name: "reports",
        initialState: initialMovementsSlice,
        reducers: { 
                StartLoadingTankSounding: (state, action) => {
                        state.tanksounding = {
                                isLoading: true,
                                report: []
                        }
                },
                SetTankSounding: (state, action) => {
                        state.tanksounding = {
                                isLoading: false,
                                report: action.payload.report
                        }
                }, 
                SetTanks: (state, action) => {
                        state.tanks = action.payload.tanks;
                }
        }
});